<template>
  <b-link :href="'mailto:' + email + '?subject=' + subjectLine" v:on-click="showAlert"> Support</b-link>
</template>

<script>
export default {
  data() {
    return {
      email: "rhyan@apgility.com",
      subjectLine: "AAR Site Support",
    };
  },
  methods: {
    showAlert: function () {
      alert("Please send an email to " + this.email + " with subject line: " + this.subjectLine + ".");
    },
  },
};
</script>
